var exports = {
  "az": "Box__TA0tdj",
  "o": "SelectorLabel__GUOdci",
  "Hh": "ActionMenu_Button__WbLbjg",
};

module.exports = exports;
